module.exports = __webpack_public_path__ + "static/img/DSC_1577_02.10bee7bc.png";